import React, { ReactElement } from 'react';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';

interface BreadCrumbType {
  link?: string;
  name: string;
}

type WealthieBreadCrumbProps = {
  breadcrumbConfig: Array<BreadCrumbType>;
};

function WealthieBreadCrumb({
  breadcrumbConfig,
}: WealthieBreadCrumbProps): ReactElement {
  return (
    <Breadcrumb style={{ margin: '16px 0' }}>
      {breadcrumbConfig.map((item: BreadCrumbType, index) => (
        <Breadcrumb.Item key={index}>
          {item.link ? <Link to={item.link}>{item.name}</Link> : item.name}
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
}

export default WealthieBreadCrumb;
